import React from "react";
import { css } from "@emotion/react";
import Helmet from "react-helmet";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";

const Layout = ({ children }) => (
  <div
    css={css`
      margin: 0 auto;
      padding: 0;
      background-color: #fdfdfd;
      padding-top: 75px;
    `}
  >
    <Helmet>
      <html lang="fr" />
    </Helmet>
    {children}
  </div>
);

export default Layout;
